import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import InputGroup from "@@/core/components/product/shared/InputGroup/InputGroup";
import TreeselectAddable from "@@/core/components/product/shared/TreeselectAddable/TreeselectAddable";
import { BFormInput } from "bootstrap-vue";

export default {
  name: "ProductInformation",
  components: {
    TreeselectAddable,
    InputGroup,
    Treeselect,
    BFormInput,
  },
  props: {
    categories: Array,
    selectedCategories: Array,
    units: Array,
    tags: Array,
    suppliers: Array,
    value: Object,
  },
  data() {
    return {
      realValue: this.value,
      lastImage: this.value.video_cover_image,
      videoCoverName: "انتخاب کاور ویدیو",
    };
  },
  mounted() {},
  computed: {
    canEditVariety() {
      return this.hasPermission("edit_price_variety_product");
    },
    realUnits() {
      return this.$root.addLabel(this.units);
    },
    realTags() {
      return this.$root.addLabel(this.tags);
    },
    realSuppliers() {
      return this.$root.addLabel(this.suppliers);
    },
    realOptions() {
      return this.$root.addLabel(this.categories);
    },
    realBrands() {
      return this.readBrands(this.selectedCategories);
    },
  },
  watch: {
    value(newVal) {
      this.realValue = newVal;
    },
    realValue(newVal) {
      this.$emit("input", newVal);
    },
    selectedCategories: function(newVal) {
      const brands = this.readBrands(newVal);
      let found = false;
      brands.forEach((brand) => {
        if (brand.id == this.realValue.brand) {
          found = true;
        }
      });
      if (!found) {
        this.realValue.brand = null;
      }
    },
  },
  methods: {
    // videoCoverChange(e) {
    //   if (e.target.files[0]) {
    //     this.videoCoverName = e.target.files[0].name;
    //     var file = e.target.files[0];
    //     var reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     let fakeThis = this;
    //     reader.onload = function() {
    //       fakeThis.realValue.video_cover_image = reader.result;
    //       if (this.mode != "create") {
    //         fakeThis.realValue.video_cover_image = reader.result;
    //       }
    //     };
    //   } else {
    //     // this.videoCoverName = "انتخاب ویدیو";
    //     this.value.video_cover_image =
    //       this.mode == "create" ? null : this.lastImage;
    //   }
    // },
    videoCoverChange(e) {
      const file = e.target.files[0];

      if (!file) {
        this.videoCoverName = "انتخاب کاور ویدیو";
        return;
      }

      this.videoCoverName = file.name;

      const reader = new FileReader();

      reader.onload = (event) => {
        this.realValue.video_cover_image = event.target.result;
      };

      reader.readAsDataURL(file);
    },
    readBrands(categories) {
      let brands = [];
      let addedBrandIds = [];
      categories.forEach((cat) => {
        cat.brands.forEach((brand) => {
          if (addedBrandIds.includes(brand.id)) {
            return;
          }
          addedBrandIds.push(brand.id);
          brands.push({
            label: brand.name,
            name: brand.name,
            id: brand.id,
          });
        });
        let brandsFromChildren = this.readBrands(cat.children);
        brandsFromChildren.forEach((b) => {
          if (addedBrandIds.includes(b.id)) {
            return;
          }
          addedBrandIds.push(b.id);
          brands.push({
            label: b.name,
            name: b.name,
            id: b.id,
          });
        });
      });

      return brands;
    },
    addTag(tag) {
      this.$emit("add-tag", tag);
    },
  },
};
